module.exports = __webpack_public_path__ + "img/succeed.48e58315.png";